export default __webpack_public_path__ + "static/media/ignat.78252c7e.png";